<template>
  <div id="productIndex">
    <!-- 筛选 -->
    <div class="filter-container searchWarp" style="margin-bottom: -10px;">
      <el-input v-model.trim="tableObj.productId" clearable :placeholder="$t('adminView.ManufactureCode')"
        class="input-with-select deviceNameTable" @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-input v-model="tableObj.sn" clearable :placeholder="$t('AllDevices.SearchDeviceSn')"
        class="input-with-select deviceNameTable" @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <search-company v-model="selectCompany2" @change="changeSearch"></search-company>
      <!-- <select-comp v-model="currentComp"></select-comp> -->
      <el-select v-model="tableObj.status" :placeholder="$t('AllDevices.Status')" clearable @change="changeSearch">
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-button type="primary" :title="$t('titles.addProOrder')" icon="el-icon-plus"
        style="vertical-align: top;margin: 10px;float: right;position: relative;z-index: 999;"
        @click="addOrEdit(null)" />
    </div>
    <el-table v-loading.body="listLoading" :data="tableList" element-loading-text="Loading" border fit
      highlight-current-row>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            
            <el-form-item label="硬件">
              <span>{{ props.row.hardwareVersion }}</span>
            </el-form-item>
            <el-form-item label="电压范围">
              <span>{{ props.row.inputRange }}</span>
            </el-form-item>
            <el-form-item label="创建者">
              <span>{{ props.row.createBy }}</span>
            </el-form-item>

          </el-form>
        </template>
      </el-table-column>
      <el-table-column :label="$t('adminView.ManufactureCode')" align="center" prop="productId" />
      
      <el-table-column :label="$t('BondOrUpdateDevice.OwnedCompany')" align="center" prop="companyName"
        show-overflow-tooltip />
      <el-table-column :label="'机型'" align="center" prop="productModel" />
      <el-table-column :label="'计划/绑定/生产'" align="center" prop="countMcuId">
        <template slot-scope="scope">
          {{scope.row.maxProduce}}/
          <el-link type="primary" @click="listYhub(scope.row)">{{ scope.row.countMcuId }}</el-link>
          /{{scope.row.nowProduce}}
        </template>
      </el-table-column>
      <el-table-column :label="'硬件'" align="center" prop="hardwareVersion" >
        <template slot-scope="scope">
          {{scope.row.hardwareVersion}}
        </template>
      </el-table-column>
      <!-- 
      <el-table-column :label="'电压范围'" align="center" prop="inputRange" /> -->
      <el-table-column :label="'使用地区'" align="center" prop="region" />

      <el-table-column :label="$t('warningPage.Remark')" align="center" prop="remark" show-overflow-tooltip />
      <!-- <el-table-column :label="$t('adminView.createBy')" align="center" prop="createBy" width="80" /> -->
      <el-table-column align="center" :label="$t('AllDevices.Status')">
        <template slot-scope="scope">
          <el-link type="primary" @click="clickStatu(scope.row)">{{ scope.row.statusZh }}</el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" :label="$t('yhubReport.Operating')">
        <template slot-scope="scope">
          <el-button type="primary" :title="$t('titles.edit')" size="mini" icon="el-icon-edit"
            @click="addOrEdit(scope.row)" />
          <el-button type="primary" :title="$t('titles.toDetail')" size="mini" icon="el-icon-view"
            @click="gotoProductDetail(scope.row)" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 列表模块————分页 -->

    <el-pagination v-if="showPage" style="margin-top: 10px;" background :current-page.sync="pageInfo.pageNum"
      :page-sizes="pageInfo.pageList" :page-size="pageInfo.limit" layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

    <!-- 状态弹窗 -->
    <el-dialog :close-on-click-modal="false" class="statusPop" width="50%" :visible.sync="isShowStautPop">
      <div>
        <p class="blockTitleP" style="margin-left: -10px;">
          {{ $t('adminView.Edit') }} {{ $t('AllDevices.Status') }}</p>
        <el-form :model="statusPopObj" label-position="right" label-width="150px">
          <el-form-item :label="$t('AllDevices.Status')">
            <el-select v-model="statusPopObj.status" :placeholder="$t('button.select')" :disabled="statuDisabled"
              @input="change($event)">
              <el-option v-for="item in statusOptions" :key="item.value" :disabled="item.disabled" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('warningPage.Remark')">
            <el-input v-model="statusPopObj.remark" :autosize="{ minRows: 4, maxRows: 8}"
              :placeholder="$t('warningSet.Pleaseenter')" style="width: 80%" type="textarea" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isShowStautPop = false">{{ $t('button.Cancel') }}</el-button>
          <el-button type="primary" :disabled="statuDisabled" @click="submitStatuPop">{{ $t('button.Submit') }}
          </el-button>
        </div>
      </div>

      <p class="blockTitleP" style="margin:10px 0 0 -10px;border-top: 1px solid #dcdfe6;">{{ $t('sim.lifeCycle') }}</p>
      <div class="baseContentWarp" style="padding-left: 10px;">
        <p v-if="statuList.length==0" style="text-align: center;">{{ $t('yhubReport.Nodata') }}</p>
        <el-steps direction="vertical" :active="statuList.length" :space="70" finish-status="process">
          <el-step v-for="(item,index) in statuList" :key="index" :title="item.title" :description="item.description" />
        </el-steps>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :title="popTitle2" width="80%" :visible.sync="isShowPop2">
      <el-button size="mini" type="primary" align="right"
        style="text-align: center;float:right;margin-bottom: 10px; margin-top: -30px;" class="el-icon-download"
        @click="downLoadBindExcel()" />
      <el-table v-loading.body="listLoading" :data="yhubList" element-loading-text="Loading" border fit
        highlight-current-row>>
        <el-table-column label="#" align="center" prop="idx" width="40" />
        <el-table-column label="MCUID" align="center" prop="mcuId" show-overflow-tooltip />
        <el-table-column label="SN" align="center" prop="sn" show-overflow-tooltip />
        <el-table-column :label="$t('adminView.barcode')" align="center" prop="barcode" show-overflow-tooltip />
        <el-table-column :label="$t('adminView.currentProductId')" align="center" prop="currentProductId"
          show-overflow-tooltip />
        <el-table-column label="FwVersion" align="center" prop="fwVersion" />
        <el-table-column label="Hardware" align="center" prop="hardware" />
        <el-table-column label="SimId" align="center" prop="simId" show-overflow-tooltip />
        <el-table-column label="PC" align="center" prop="pc" />
        <el-table-column :label="$t('adminView.createBy')" align="center" prop="createBy" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openLogTable(scope.row.mcuId, scope.row.sn)">测试记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog width="70%" :title="'测试记录：'+ currentSn" :visible.sync="innerVisible" append-to-body>
        <el-table :data="testLogs" border fit highlight-current-row>
          <el-table-column label="步骤" align="center" prop="step" width="50" />
          <el-table-column label="项目名称" align="center" prop="name" width="250" />
          <el-table-column label="数据" align="center" prop="stepData">
            <template slot-scope="scope">
              <div v-html="scope.row.extend"></div>
            </template>
          </el-table-column>
          <el-table-column label="来源" align="center" prop="source" width="50" />
          <el-table-column label="时间" align="center" prop="createTime" width="160">
            <template slot-scope="scope">
              <span>{{scope.row.createTime | timeFormat}}</span>
            </template>
          </el-table-column>
          <el-table-column label="测试人" align="center" prop="createBy" width="60" />

        </el-table>
      </el-dialog>
    </el-dialog>

  </div>
</template>

<script>
import { pageProductConfig, updateStatusById, tmpBindList, getProductLog } from '@/api/product'
import i18n from '@/i18n'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime.js'
import SelectComp from '@/components/SelectComp.vue'
export default {
  components: { SelectComp },
  data () {
    return {
      currentComp: '',
      showPage: false,
      tableObj: {
        productId: '',
        status: ''
      },
      tableList: null,
      listLoading: true,
      isAdd: true,
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        pageNo: 1,
        total: 0,
        pageList: [10, 20, 30, 50]
      },
      dialogObj: {
        ownCompany: ''
      },
      inputRangeOptions: ['12 to 72 VDC', '48 to 120 VDC'],
      isShowStautPop: false,
      statusPopObj: {
        status: null,
        remark: null
      },
      statuDisabled: true, // 状态是否可编辑
      statuList: [],
      currentObj: {},
      isShowPop2: false,
      yhubList: null,
      popTitle2: i18n.t('adminView.showBind'),
      productConfigId: '',
      selectCompany: [],
      selectCompany2: [],
      innerVisible: false,
      currentSn: '',
      testLogs: []
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    },
    waterLevelOptions () {
      return [
        { value: 0, label: i18n.t('adminView.No') },
        { value: 1, label: i18n.t('adminView.Bayonet') },
        { value: 2, label: i18n.t('adminView.Drillhole') },
        { value: 3, label: i18n.t('adminView.WaterFillCover') }
      ]
    },
    statusOptions () { // 当前最新状态：1.审核中、2.生产中、3仓库中、4已发货、5已收货
      return [
        { value: 1, label: i18n.t('adminView.underReview') },
        { value: 2, label: i18n.t('adminView.inProduction') },
        { value: 3, label: i18n.t('adminView.InWarehouse') },
        { value: 4, label: i18n.t('adminView.Shipped') },
        { value: 5, label: i18n.t('adminView.received') }
      ]
    },
    netModuleOptions () {
      return [
        { value: 'EC20-EA', label: 'EC20-EA (' + i18n.t('adminView.Default') + ')' },
        { value: 'EC25-AU', label: 'EC25-AU' },
        { value: 'EC25-AF', label: 'EC25-AF' },
        { value: 'EC25-EUX', label: 'EC25-EUX' },
        { value: 'M5700', label: 'M5700' }
      ]
    },
    mainCurrentOptions () {
      return [
        { value: 0, label: i18n.t('adminView.No') },
        { value: 1, label: i18n.t('adminView.Hall300') },
        { value: 2, label: i18n.t('adminView.Hall800') },
        { value: 3, label: i18n.t('adminView.Shunt300') },
        { value: 4, label: i18n.t('adminView.Shunt300').replace('300', 750) }
      ]
    },
    antennaPlaceOptions () {
      return [
        { value: 0, label: i18n.t('adminView.No') },
        { value: 1, label: i18n.t('adminView.External4G') },
        { value: 2, label: i18n.t('adminView.External4GGPS') },
        { value: 3, label: i18n.t('adminView.Internal4G') },
        { value: 4, label: i18n.t('adminView.Internal4GGPS') }
      ]
    },
    hardwareProOptions () {
      return [
        { value: 0, label: i18n.t('adminView.No') },
        { value: 1, label: i18n.t('adminView.system12') },
        { value: 2, label: i18n.t('adminView.system24') },
        { value: 3, label: i18n.t('adminView.system36') },
        { value: 4, label: i18n.t('adminView.system48') },
        { value: 5, label: i18n.t('adminView.system60') },
        { value: 6, label: i18n.t('adminView.system72') },
        { value: 7, label: i18n.t('adminView.system84') }
      ]
    }
  },
  mounted () {
    const p = sessionStorage.getItem('admin_product_page_num') || 1
    this.pageInfo.pageNum = parseInt(p)
    this.queryList()
  },
  methods: {
    getDataFormat (obj1) {
      let str1 = ''
      let str2 = ''
      for (const key in obj1) {
        if (Object.hasOwnProperty.call(obj1, key)) {
          if (typeof obj1[key] == 'object') {
            str2 += '<p class="json_str">' + key + ': ' + JSON.stringify(obj1[key]) + '</p>'
          } else {
            if (key != 'name' && key != 'action') {
              str1 += '<p>' + key + ': ' + obj1[key] + '</p>'
            }
          }
        }
      }
      return str1 + str2
    },
    openLogTable (mcuId, sn) {
      this.currentSn = sn
      this.innerVisible = true
      getProductLog(mcuId).then(res => {
        console.log(res)
        // this.testLogs = res.resultModel
        const list = res.resultModel || []
        list.sort((a, b) => b.createTime - a.createTime)
        console.log(list)
        const stepArr = []
        const arr = []
        list.forEach(item => {
          const isRep = stepArr.indexOf(item.step) >= 0
          if (!isRep) {
            const obj = JSON.parse(item.stepData)
            stepArr.push(item.step)
            arr.push({
              step: item.step,
              name: obj.name || obj.action,
              source: item.source,
              createBy: item.createBy,
              createTime: item.createTime,
              extend: this.getDataFormat(obj)
            })
          }
        })
        this.testLogs = arr
      })
    },
    queryList () {
      this.listLoading = true
      var param = {
        companyIdList: this.selectCompany,
        productId: this.tableObj.productId || '',
        sn: this.tableObj.sn || '',
        status: this.tableObj.status || '', // 1.审核中、2.生产中、3仓库中、4已发货、5已收货
        pageNum: this.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.showPage = false
      console.log(param)
      pageProductConfig(param).then(res => {
        this.showPage = true
        console.log('表格数据：', res)
        this.listLoading = false
        if (res.resultCode != 1001 || !res.resultModel) {
          this.tableList = []
          this.pageInfo.total = 0
          return
        }
        this.tableList = res.resultModel.list || []
        this.pageInfo.total = res.resultModel.total // 分页
        if (this.tableList.length == 0) return
        this.tableList.forEach(v => {
          v.mainCurrentSensorTypeZh = this.mainCurrentOptions[v.mainCurrentSensorType].label
          v.isDisabledEdit = v.nowProduce > 0
          switch (v.interLockSocket) { // 车锁接口
            case 0: v.interLockSocketZh = i18n.t('adminView.No'); break
            case 1: v.interLockSocketZh = i18n.t('adminView.NormallyOpen'); break
            case 2: v.interLockSocketZh = i18n.t('adminView.NormallyClose'); break
          }
          this.waterLevelOptions.forEach(m => { // 液位接口
            if (m.value == v.waterLevelSocket) v.waterLevelSocketZh = m.label
          })
          this.statusOptions.forEach(m => {
            if (m.value == v.status) v.statusZh = m.label
          })
          this.antennaPlaceOptions.forEach(m => {
            if (m.value == v.antennaPlace) v.antennaPlaceZh = m.label
          })
          this.netModuleOptions.forEach(m => {
            if (m.value == v.netModule) v.netModuleZh = m.label
          })
          // 硬件低压保护
          this.hardwareProOptions.forEach(m => {
            if (m.value == v.hardwareProtection) v.hardwareProtectionZh = m.label
          })
          v.signalASocketZh = v.signalASocket === 1 ? i18n.t('BondOrUpdateDevice.Yes') : i18n.t('adminView.No')
          v.signalBSocketZh = v.signalBSocket === 1 ? i18n.t('BondOrUpdateDevice.Yes') : i18n.t('adminView.No')
          v.auxBatteryVoltageZh = v.auxBatteryVoltage === 1 ? i18n.t('BondOrUpdateDevice.Yes') : i18n.t('adminView.No')
          v.auxBatteryCurrentZh = v.auxBatteryCurrent === 1 ? i18n.t('BondOrUpdateDevice.Yes') : i18n.t('adminView.No')
          v.canSocketZh = v.canSocket === 1 ? i18n.t('BondOrUpdateDevice.Yes') : i18n.t('adminView.No')
          v.rs485SocketZh = v.rs485Socket === 1 ? i18n.t('BondOrUpdateDevice.Yes') : i18n.t('adminView.No')
          v.tempraturePlaceZh = v.tempraturePlace === 1 ? i18n.t('adminView.NegativePost') : i18n.t('adminView.Separated')
        })
      })
    },
    addOrEdit (row) { // 打开新增/编辑弹窗
      sessionStorage.setItem('admin_product_item', JSON.stringify(row))
      this.$router.push({ path: '/product/productAddEdit' })
    },
    gotoProductDetail (row) { // 去详情页 202205230001  202109220002 202107190004
      sessionStorage.setItem('admin_product_item', JSON.stringify(row))
      this.$router.push({
        path: '/product/productDetail', query: {
          productId: row.productId
        }
      })
      // if (row) { // 编辑
      //   this.dialogObj = JSON.parse(JSON.stringify(row))
      //   var routeData = this.$router.resolve({
      //     path: '/product/productDetail',
      //     query: { productId: this.dialogObj.productId, inputRange: this.dialogObj.inputRange, labelRemark: this.dialogObj.labelRemark }
      //   })
      //   window.open(routeData.href, '_self')
      // }
    },
    change (e, val) {
      this.$forceUpdate()
    },
    // 筛选改变事件
    changeSearch () {
      this.selectCompany = []
      this.selectCompany2.forEach(v => {
        this.selectCompany.push((typeof v === 'string' && v.indexOf('ID') > -1) ? v.slice(2) : v)
      })
      this.pageInfo.pageNum = 1
      this.pageInfo.pageSize = 10
      this.queryList()
    },
    clickStatu (row) { // 点击状态--打开状态弹窗
      this.isShowStautPop = true
      this.statusPopObj.status = row.status
      this.currentObj = JSON.parse(JSON.stringify(row))
      if (row.status && this.$store.state.isAdmin) {
        this.statuDisabled = false
      } else {
        this.statuDisabled = true
      }
      if (!this.$store.state.isAdmin) {
        this.statusOptions.forEach(v => {
          v.disabled = !(v.value == row.status + 1 || v.value == row.status)
        })
      }
      var list = JSON.parse(row.statusInfo) || []
      this.statuList = []
      list.forEach(v => {
        v.time = getDateAndHour(v.createTime)
        this.statusOptions.forEach(m => {
          if (m.value == v.status) v.label = m.label
        })
        v.remark = v.remark ? v.remark : ''
        this.statuList.push({
          title: v.label,
          description: v.time + '   ' + v.remark + '   [ ' + i18n.t('QR.Uploader') + ': ' + v.createBy + ' ]'
        })
      })
      // console.log('this.statusOptions', this.statusOptions)
    },
    submitStatuPop () { // 提交状态更改
      var param = {
        'productId': this.currentObj.productId,
        'remark': this.statusPopObj.remark,
        'status': this.statusPopObj.status
      }
      if (this.statusPopObj.status == 2 && this.currentObj.status == 1) {
        this.$confirm(i18n.t('adminView.statusChange'), '', {// 确认审核通过，状态变更为生产中吗？
          confirmButtonText: i18n.t('button.Confirm'), // '确定'
          cancelButtonText: i18n.t('button.Cancel'),
          type: 'warning'
        }).then(() => {
          this.updateStatusFn(param)
        }).catch(() => { })
      } else {
        this.updateStatusFn(param)
      }
    },
    updateStatusFn (param) { // 提交状态
      updateStatusById(param).then(res => {
        if (res.resultCode == '1001') {
          this.$message({
            type: 'success',
            message: i18n.t('warningSet.submitted')
          })
          this.isShowStautPop = false
          this.queryList()
        }
      })
    },

    listYhub (row) {
      this.popTitle2 = i18n.t('adminView.showBind')
      this.isShowPop2 = true
      if (row) { // 编辑
        this.dialogObj = JSON.parse(JSON.stringify(row))
        this.popTitle2 = i18n.t('adminView.showBind') + '(' + this.dialogObj.productId + ')'
        // alert(this.dialogObj.productId)
        tmpBindList(this.dialogObj.productId).then(response => {
          this.yhubList = response.resultModel || []
          this.productConfigId = this.dialogObj.productId
        })
      }
    },
    downLoadBindExcel () {
      var url = process.env.VUE_APP_BASE_API + '/v3/manager/productConfig/exportProductBindList?productConfigId=' + this.productConfigId
      window.open(url, '_bank')
    },
    // 分页----start
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.pageInfo.pageNum = val
      sessionStorage.setItem('admin_product_page_num', val)
      this.queryList()
    }
    // 分页----end
  }
}
</script>
<style lang="scss">
.json_str {
  background-color: #ddd;
  height: 30px;
  overflow: hidden;
  border-bottom: 5px solid #fff;
  &:hover {
    height: auto;
  }
}
#productIndex {
  background: #fff;
  padding: 0 20px 20px;
  .searchWarp .el-input-group {
    width: 20% !important;
    max-width: 400px !important;
    margin-top: 13px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  #productPop,
  #configPop {
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-input-number--medium,
    .el-input--medium {
      width: 200px;
    }
  }
  .remarkPop {
    width: 100%;
  }
  .remarkPop .el-form-item__content {
    width: calc(100% - 200px);
  }
  .lastRadio {
    margin-right: 0;
  }
  .statusPop {
    .el-form-item {
      margin-bottom: 20px;
    }
    .dialog-footer {
      text-align: right;
      width: calc(80% - 120px);
      margin-left: 150px;
    }
  }
}
</style>
